import VueTables from 'vue-tables-2-premium';
import moment from 'moment';

const defaultTexts = {
  count: 'Showing {from} to {to} of {count} rows|Showing all {count} rows|',
  first: 'First',
  last: 'Last',
  filter: 'Filter:',
  filterPlaceholder: 'Search query',
  limit: 'Records:',
  page: 'Page:',
  noResults: 'No matching records',
  noRequest: 'Please select at least one filter to fetch results',
  filterBy: 'Filter by {column}',
  loading: 'Loading...',
  defaultOption: 'Select {column}',
  columns: 'Columns',
  showPerPageText: 'Show|results per page'
};
const queryParamsFlaskMap = {
  ascending: 'asc',
  limit: 'per_page',
  orderBy: 'order_by',
  search_role: 'search_role_id'
};
let tablesIncrementer = 0;
var script = /*#__PURE__*/{
  name: 'table-component',
  // vue component name
  props: {
    addCollapseCellValue: {
      type: Array,
      default: () => []
    },
    tableName: String,
    visibleColumnsFilters: {
      type: Function,
      default: columnName => columnName !== '_id'
    },
    url: String,
    childUrl: String,
    defaultOrderBy: String,
    sublevelOrderBy: String,
    defaultAsc: String,
    defaultPerPage: Number,
    paginationBreakpoint: Number,
    color: String,
    columns: Array,
    columnsMeta: Array,
    booleanFilterDefaultOptions: {
      type: Array,

      default() {
        return [{
          label: "All",
          value: undefined
        }, {
          label: "Yes",
          value: true
        }, {
          label: "No",
          value: false
        }];
      }

    },
    forceFilter: {
      type: Boolean,
      default: false
    },
    useOnlySpecifiedColumns: {
      type: Boolean,
      default: false
    },
    childRowOverwritten: {
      type: Boolean,
      default: false
    },
    keepId: {
      type: Boolean,
      default: false
    },
    encodeFilters: {
      type: Boolean,
      default: true
    },
    exportUrl: {
      type: String,
      default: ''
    },
    cellClasses: {
      type: Object,

      default() {
        return {};
      }

    },
    addNumericalColumns: {
      type: Array,

      default() {
        return [];
      }

    },
    tableDateFormat: {
      type: String,
      default: "YYYY-MM-DD"
    },
    paginationTextPosition: {
      type: String,
      default: "top"
    },
    tokenBearer: {
      type: String,
      default: "JWT"
    },
    handleRequestError: {
      type: Function,
      default: () => {}
    },
    addTableClasses: {
      type: String,
      default: ''
    },
    lazyTable: {
      type: Object,

      default() {
        return {};
      }

    },
    defaultSublevelColumnVisibility: {
      type: Array,

      default() {
        return [];
      }

    },
    defaultColumnVisibility: {
      type: Array,

      default() {
        return [];
      }

    },
    filterAlgorithm: {
      type: Object,

      default() {
        return {};
      }

    },
    replaceColumnValues: {
      type: Object,

      default() {
        return {};
      }

    },
    clientTableGroupByColumn: String,
    externalGroupByColumn: String,
    filterExcludeColumns: {
      type: Array,

      default() {
        return ['_id'];
      }

    },
    sortExcludeColumns: {
      type: Array,

      default() {
        return ['_id'];
      }

    },
    hiddenColumns: {
      type: Array,

      default() {
        return [];
      }

    },
    lineViewFilterExcludeColumns: {
      type: Array,

      default() {
        return [];
      }

    },
    data: Array,
    externalColumns: Array,
    settings: Object,
    onResult: Function,
    isTableGroupedDetails: {
      type: Boolean,
      default: false
    },
    showTopNumberOfRecords: {
      type: Boolean,
      default: true
    },
    disablePagination: {
      type: Boolean,
      default: false
    },
    showPerPageSelector: {
      type: Boolean,
      default: true
    },
    shouldHideTable: {
      type: Boolean,
      default: false
    },
    downloadFileName: {
      type: String,
      default: ''
    },
    disableSearchParams: {
      type: Boolean,
      default: false
    },
    headings: {
      type: Object,

      default() {
        return {};
      }

    },
    tableOverrideFilters: {
      type: Object,

      default() {
        return {};
      }

    },
    theme: String,
    initFilters: {
      type: Object,

      default() {
        return {};
      }

    },
    lineViewInitFilters: {
      type: Object,

      default() {
        return {};
      }

    },
    initPage: {
      type: Number,
      default: 1
    },
    filterable: {
      type: Boolean,
      default: true
    },
    rowClassCallbackFunction: {
      type: Function,
      default: () => ''
    },
    beforeDestroyCallback: {
      type: Function,
      default: () => ''
    },
    onPaginationCallback: {
      type: Function,
      default: () => ''
    },
    showGenerateExcelBtn: {
      type: Boolean,
      default: true
    },
    exportVisibleColumnsOnly: {
      type: Boolean,
      default: true
    },
    exportColumns: {
      type: Array,

      default() {
        return [];
      }

    },
    notFormattedColumns: {
      type: Array,

      default() {
        return [];
      }

    },
    shouldAllowRowSelection: {
      type: Boolean,
      default: false
    },
    disableRowSelection: {
      type: Boolean,
      default: false
    },
    enableSelectAllRowsOnServerTable: Boolean,
    selectionColumn: {
      type: String,
      default: '_id'
    },
    rowSelectionButtonText: {
      type: String,
      default: 'Execute'
    },
    defaultPerPageSelector: {
      type: Boolean,
      default: true
    },
    ignoreZeroValues: {
      type: Boolean,
      default: true
    },
    showNumberOfLines: {
      type: Boolean,
      default: true
    },
    perPageValues: {
      type: Array,

      default() {
        return [10, 25, 50];
      }

    },
    displayColumnsSelector: {
      type: Boolean,
      default: true
    },
    saveState: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      isRowCollapsed: null,
      tableId: 0,
      requestUrl: null,
      showTable: false,
      shouldCollapseChildRows: false,
      tableQuery: {},
      tableColumns: [],
      isInitializing: true,
      filterValues: {},
      dateRangeValues: {},
      activeFilterColumns: [],
      hasRowTemplate: false,
      paginationText: '',
      lazyTableId: null,
      lazyTableExportExists: null,
      lazyTableExportFilename: null,
      lazyTableExportGenerating: false,
      isLoadingTable: false,
      blockedLoading: false,
      permanentlyBlockedLoading: false,
      queryString: '',
      options: null,
      visibleRows: [],
      selectedRows: [],
      numericalColumns: [],
      wasRowsSelectionExecuted: false,
      columnsModalVisible: false,
      shouldRefreshTable: false,
      detailOnly: false,
      visibleColumns: {},
      sublevelVisibleColumns: {},
      selectedGroups: {},
      totalNumberOfRecords: 0,
      allowedNumberOfObjectIds: 0,
      count: 0,
      currentTableCount: 0,
      currentPage: 1,
      totalPages: 1,
      savedState: {},
      shouldSelectAllRows: false
    };
  },

  beforeDestroy() {
    this.beforeDestroyCallback();
    this.setSearchParam(`filters${this.lazyTable.key ? `_${this.lazyTable.key}` : ''}`, null);
    this.$root.$off('rerenderTable', this.rerenderTable);
  },

  created() {
    this.createOptions();
    this.tableId = ++tablesIncrementer;
    this.$root.$on('perPageSet', value => this.setPerPageValue(value));
  },

  mounted() {
    this.savedState = JSON.parse(localStorage.getItem(`vuetables_${this.tableName}`));
    this.$root.$on('rerenderTable', this.rerenderTable);
    this.initTable();
    this.initFilterValues();
  },

  watch: {
    columns(newColumns, oldColumns) {
      const hasChanged = `${newColumns}` !== `${oldColumns}`;

      if (hasChanged) {
        this.createOptions();
        this.initTable();
      }
    }

  },
  computed: {
    computedColumnsMeta() {
      const columns = this.columnsMeta || this.lazyTable.columns || this.columns || [];
      return columns.map(colName => {
        if (typeof colName === "string") {
          return {
            "name": colName,
            "type": 'text'
          };
        }

        return colName;
      });
    },

    computedTableTexts() {
      const tableTexts = { ...defaultTexts,
        ...this.tableTexts
      };
      return Object.fromEntries(Object.entries(tableTexts).map(([key, value]) => [key, this.t(`table.${key}`, false) || this.t(value)]));
    },

    computedHeadings() {
      const headings = {
        "role.name": "Role",
        created_at: "Date registered",
        firstname: "First name",
        lastname: "Last name",
        _id: "",
        ...(this.headings || {})
      };

      if (!this.$t) {
        return headings;
      }

      return { ...Object.fromEntries(this.tableColumns.map(column => [column, this.$t(this.capitalize(`${column}`.replaceAll("_", " ")))])),
        ...Object.fromEntries(Object.entries(headings).map(([column, value]) => [column, this.$t(value)]))
      };
    },

    exportFilename() {
      return this.downloadFileName ? this.downloadFileName : this.lazyTableExportFilename.split('.').slice(1).join('.').toUpperCase();
    },

    perPageLocalStorageAccessor() {
      const defaultAccessor = 'tableResultsPerPage';
      if (this.theme) return `${this.theme}-${defaultAccessor}`;
      return defaultAccessor;
    },

    initialPerPageValue() {
      return this.disablePagination ? 9999 : this.defaultPerPage || localStorage.getItem(this.perPageLocalStorageAccessor) || this.perPageValues[0];
    },

    selectedPerPageValue() {
      return this.tableQuery["per_page"] || this.initialPerPageValue;
    },

    shouldHideTableFilters() {
      return this.areArraysEqual(this.filterExcludeColumns || [], this.computedColumnsMeta.map(colObj => colObj.name));
    },

    tableExportUrl() {
      return this.exportUrl || `${this.apiUrl}api/lazytable/${this.lazyTableExportFilename || this.lazyTableId}/export`;
    },

    canExportTable() {
      return this.exportUrl || this.lazyTableId && this.showGenerateExcelBtn && !this.detailOnly;
    },

    columnsToDisplay() {
      const visibleColumns = this.tableColumns.filter(c => this.visibleColumns[c]);

      if (this.hasRowTemplate) {
        visibleColumns.unshift('row');
      }

      return visibleColumns;
    },

    sublevelColumnsToDisplay() {
      return this.lazyTable.raw_table.columns.map(c => c.name).filter(c => this.sublevelVisibleColumns[c]);
    },

    activeFilterList() {
      return Object.entries(this.options.urlFilters).filter(([_, val]) => ![undefined, null].includes(val)).map(([key, _]) => key);
    }

  },
  methods: {
    handleCollapseRow(event) {
      event.target.parentNode.children[1].classList.toggle('d-flex');
      event.target.classList.toggle('fa-plus-circle');
      event.target.classList.toggle('fa-minus-circle');
    },

    t(text, defaultToKey = true) {
      return this.$t && this.$te && this.$te(text) ? this.$t(text) : defaultToKey ? text : null;
    },

    capitalize(text) {
      return text.slice(0, 1).toUpperCase() + text.slice(1);
    },

    getSelectOptions(column, definedOptions = null) {
      let options = definedOptions || this.tableOverrideFilters[column].options;
      if (!options || !options.length) return [];
      const hasAllSelector = options.find(option => option.name === 'All' || option.label === 'All');
      if (!hasAllSelector) options = [{
        label: this.t('All'),
        value: undefined
      }, ...options];
      return options;
    },

    isColumnNumerical(column) {
      if (!column.type) {
        return this.numericalColumns.includes(column.name);
      }

      return column.type.toLowerCase().includes('int') || column.type.toLowerCase().includes('float') || this.numericalColumns.includes(column.name);
    },

    rowLength(value) {
      return Array.isArray(value) ? value.join('').length : value && typeof value !== typeof {} ? value.toString().length : 0;
    },

    areArraysEqual(array1, array2) {
      const sortedArray1 = [...array1].sort();
      const sortedArray2 = [...array2].sort();
      return sortedArray1.length === sortedArray2.length && sortedArray1.every(function (value, index) {
        return value === sortedArray2[index];
      });
    },

    rerenderTable(tableName) {
      if (!tableName || tableName === this.tableName) this.$forceUpdate();
    },

    getFilterPlaceholder(column) {
      const headingName = this.computedHeadings[column];
      const columnName = headingName || column.replaceAll("_", " ");
      return this.computedTableTexts.filterBy.replace("{column}", columnName);
    },

    getRowsCountText(type) {
      const rowCounters = this.computedTableTexts.count;
      return rowCounters.split('|')[type];
    },

    replaceCounterValues(type, from, count, to, maxRows) {
      return this.getRowsCountText(type).replace("{from}", from).replace("{to}", to.toString()).replace("{count}", maxRows);
    },

    initFilterValues() {
      if (this.computedColumnsMeta) {
        this.computedColumnsMeta.forEach(({
          name,
          type
        }) => {
          this.filterValues[name] = undefined;

          if (type === "date_range") {
            this.dateRangeValues[name] = this.dateRangeValues[name] || {
              startDate: null,
              endDate: null
            };
          }
        });
      }
    },

    setCurrentFilterValues() {
      this.initFilterValues();

      if (this.options.urlFilters) {
        Object.entries(this.options.urlFilters).forEach(([name, value]) => {
          if (value) {
            this.$set(this.filterValues, name, value);
          }
        });
      }
    },

    getPandasTypeToHelpType(type) {
      const numberTypes = ["float64", "int64", "number"];
      const dateTypes = ["datetime64[ns]", "date_range", "date"];
      const textTypes = ["text", "string", "object"];
      if (numberTypes.includes(type)) return "number";
      if (dateTypes.includes(type)) return "date";
      if (textTypes.includes(type)) return "text";
      return null;
    },

    getFilterDoc(type, source = 'server') {
      let docsMessages = {
        "date": {
          examples: [{
            title: this.t("get dates before 2020-10-01"),
            example: "<2020-10-01"
          }, {
            title: this.t("get dates between 2020-10-01 and 2020-12-30"),
            example: ">=2020-10-01&<=2020-12-30"
          }, {
            title: this.t("get dates before 2020-10-01 and after 2020-12-30"),
            example: "<=2020-10-01|>=2020-12-30"
          }, {
            title: this.t("get 2020-11-11 or 2020-12-12"),
            example: "2020-11-11|2020-12-12"
          }],
          operators: "<, >, <=, >=, &, |"
        },
        "number": {
          examples: [{
            title: this.t("get values less then 250"),
            example: "<250"
          }, {
            title: this.t("get values more or equal to 550"),
            example: ">=550"
          }, {
            title: this.t("get values between 250 and 550"),
            example: ">=250&<=550"
          }, {
            title: this.t("get values less then 250 and larger then 550"),
            example: "<=250|>=550"
          }, {
            title: this.t("get values 300 or 500"),
            example: "300|500"
          }],
          operators: "<, >, <=, >=, &, |"
        },
        "text": {
          examples: [{
            title: this.t("get Joe or Adam"),
            example: "Joe|Adam"
          }, {
            title: this.t("does not contain Joe nor Adam"),
            example: "^(?!.*(Joe|Adam)).*"
          }, {
            title: this.t("not starting with urssaf"),
            example: "^(?!urssaf).*"
          }, {
            title: this.t("not starting by xyz nor tuv"),
            example: "^(?!(xyz|tuv)).*"
          }, {
            title: this.t("ending with xzy or tuv"),
            example: ".*xzy|tuv"
          }, {
            title: this.t("different than xzy and tuv"),
            example: "^(?!(xyz|tuv))"
          }]
        }
      };

      if (source !== 'server') {
        docsMessages = {
          "date": {
            examples: [{
              title: this.t("Dates in 2020"),
              example: "2020"
            }, {
              title: this.t("find record with date 2020-12-12"),
              example: "2020-12-12"
            }],
            operators: "None"
          },
          "number": {
            examples: [{
              title: this.t("get values containing 300"),
              example: "300"
            }],
            operators: "None"
          },
          "text": {
            examples: [{
              title: this.t("get values containing Joe"),
              example: "Joe"
            }]
          }
        };
      }

      const option = docsMessages[this.getPandasTypeToHelpType(type)];
      if (!option) return;
      return `
          <div style='display: block;'>
            <strong>${this.t('Filter examples')}:</strong>
            <br>
            ${option.operators ? `<i>${this.t('available operators')}:</i><br><i>${option.operators}</i><br>` : ``}
            <hr style='margin: 0.2rem 0;'>
            ${option.examples.map(tip => `
              <div style='display: block;'>
                <strong>${tip.title}</strong><br>
                <div>${tip.example}</div>
              </div>
            `).join('')}
          </div>
        `;
    },

    clearAllFilters(queryKey) {
      Object.keys(this.tableQuery).forEach(parameter => {
        this.updateQuery(parameter, null);
      });
      Object.keys(this.options.urlFilters).forEach(parameter => {
        this.$set(this.options.urlFilters, parameter.split('.')[0], null);
      });
      this.setSearchParam(queryKey, null);
      this.lazyTableExportExists = false;
      this.lazyTableExportFilename = null;
    },

    updateQuery(queryName, queryValue) {
      if (queryValue === null) {
        delete this.tableQuery[queryName];
      } else this.$set(this.tableQuery, queryName, queryValue);
    },

    subTableDataCount(tableCount) {
      this.count = tableCount;
    },

    resetVisibleColumns(hide) {
      Object.keys(this.visibleColumns).forEach(c => {
        this.visibleColumns[c] = this.defaultColumnVisibility.length ? this.defaultColumnVisibility.includes(c) : hide;
      });
      Object.keys(this.sublevelVisibleColumns).forEach(c => {
        this.sublevelVisibleColumns[c] = this.defaultSublevelColumnVisibility.length ? this.defaultSublevelColumnVisibility.includes(c) : hide;
      });
    },

    getDisplayValue(value, columnName = '') {
      if (this.replaceColumnValues[columnName]) value = this.replaceColumnValues[columnName][value] || value;

      if (this.notFormattedColumns.includes(columnName)) {
        if (!this.ignoreZeroValues && parseFloat(value) === 0) {
          return value;
        }

        return value || '-';
      }

      const dateReg = new RegExp('^\\d{1,4}[./-]\\d{1,4}[./-]\\d{1,4}$');
      const timeRegExp = new RegExp('^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])$');
      const dateValue = moment(value);
      const unpackedIsoDate = `${value}`.split('T')[0];
      const parsedUnpackedIsoDate = moment(unpackedIsoDate);

      if (dateReg.test(value) && isNaN(typeof value === 'string' ? value.replace(',', '.') : value) && dateValue.isValid()) {
        return dateValue.format(this.tableDateFormat);
      } else if (dateReg.test(unpackedIsoDate) && parsedUnpackedIsoDate.isValid()) {
        return parsedUnpackedIsoDate.format(this.tableDateFormat);
      } else if (timeRegExp.test(value)) {
        return moment(value, "HH:mm:ss").format("HH:mm");
      } else return value === null || value === undefined || value === "" ? '-' : `${this.getNumericalValue(value)} ${columnName.includes('%') ? ' %' : ''}`;
    },

    getNumericalValue(value, round = 2, zeroValue = '-') {
      if (value === '0.0 %') {
        return '0 %';
      }

      if (typeof value === typeof 1) {
        if (value === 0 && this.ignoreZeroValues) {
          return zeroValue;
        }

        value = value.toFixed(round).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
      }

      if (value === '0' && this.ignoreZeroValues) {
        return zeroValue;
      }

      return value;
    },

    emitSelectedRows() {
      this.$emit('row-selected', this.selectedRows, this.shouldSelectAllRows);
    },

    deSelectAllRows(shouldInitTable = true) {
      this.shouldSelectAllRows = false;
      this.wasRowsSelectionExecuted = false;
      this.updateQuery('search_id__in', null);
      this.selectedRows = [];
      this.emitSelectedRows();

      if (shouldInitTable && this.requestUrl) {
        return this.$refs.table.getData();
      }
    },

    handleSelectRowsAction() {
      this.wasRowsSelectionExecuted = true;

      if (this.requestUrl) {
        return this.$refs.table.getData();
      }
    },

    selectVisibleRows() {
      this.wasRowsSelectionExecuted = false;
      this.shouldSelectAllRows = false;
      const visibleRowsCount = this.selectedPerPageValue;
      const data = this.$refs.table.allFilteredData || this.$refs.table.data;

      if (!this.url) {
        data.forEach((row, index) => {
          if (!this.selectedRows.find(selectedRow => selectedRow[this.selectionColumn] === row[this.selectionColumn]) && index >= visibleRowsCount * (this.currentPage - 1) && index < visibleRowsCount * this.currentPage) {
            this.selectedRows.push(row);
          }
        });
      } else {
        data.forEach((row, index) => {
          if (!this.selectedRows.find(selectedRow => selectedRow[this.selectionColumn] === row[this.selectionColumn]) && index < visibleRowsCount) this.selectedRows.push(row);
        });
      }

      this.emitSelectedRows();
    },

    selectAllRows() {
      this.wasRowsSelectionExecuted = false;
      this.shouldSelectAllRows = true;
      const data = this.$refs.table.allFilteredData || this.$refs.table.data;
      data.forEach((row, index) => {
        if (!this.selectedRows.find(selectedRow => selectedRow[this.selectionColumn] === row[this.selectionColumn]) && index < data.length) this.selectedRows.push(row);
      });
      this.emitSelectedRows();
    },

    handleRowSelection(addedRow) {
      this.wasRowsSelectionExecuted = false;
      this.shouldSelectAllRows = false;

      if (this.selectedRows.find(selectedRow => selectedRow[this.selectionColumn] === addedRow[this.selectionColumn])) {
        this.selectedRows = this.selectedRows.filter(row => row[this.selectionColumn] !== addedRow[this.selectionColumn]);

        if (!this.selectedRows.length && this.requestUrl) {
          this.updateQuery('search_id__in', null);
          this.$refs.table.getData();
        }
      } else this.selectedRows.push(addedRow);

      this.emitSelectedRows();
    },

    setFilterValue(value, columnName, type = 'text') {
      const valueToSet = type === 'date' && value ? value.toString() : value;
      this.$refs.table.setFilter({
        [columnName]: valueToSet
      });
      this.$set(this.filterValues, columnName, valueToSet);

      if (!this.requestUrl) {
        const newQuery = { ...this.$route.query
        };
        const searchKey = `search_${columnName}`;
        if (value) newQuery[searchKey] = valueToSet;else delete newQuery[searchKey];
        this.$router.replace({
          query: newQuery
        }).catch(err => err);
        this.shouldRefreshTable = !this.shouldRefreshTable;
      }
    },

    filterHandler(value, columnName, type = 'text') {
      if (value === null && type === "date_range") this.dateRangeValues[columnName] = {
        startDate: null,
        endDate: null
      };
      this.setFilterValue(value, columnName, type);
    },

    inputFilterHandler(e, columnName) {
      const value = e.target.value;
      this.filterHandler(value, columnName);
      e.target.style = value.length ? 'border: 3px solid rgb(79, 123, 59); background-color: rgba(79, 123, 59, 0.2)' : '';
      this.lazyTableExportExists = false;
      this.lazyTableExportFilename = null;
    },

    dateFilterHandler(value, columnName) {
      this.filterHandler(value.trim(), columnName, 'date');
    },

    dateRangeFilterHandler(startDate, endDate, columnName) {
      if (startDate) this.dateRangeValues[columnName].startDate = startDate;
      if (endDate) this.dateRangeValues[columnName].endDate = endDate;
      let filterQuery = "";
      const {
        startDate: start,
        endDate: end
      } = this.dateRangeValues[columnName];
      if (start && end) filterQuery = `>=${start}T00:00:00&<=${end}T23:59:59`;else if (start && !end) filterQuery = `>=${start}T00:00:00`;else if (!start && end) filterQuery = `<=${end}T23:59:59`;

      if (filterQuery !== "") {
        this.$refs.table.setFilter({
          [columnName]: filterQuery
        });
      }
    },

    getUrlParams() {
      const queryKey = `filters${this.lazyTableId ? `_${this.lazyTableId}` : ''}`;
      let urlParams = {};

      try {
        urlParams = this.requestUrl ? JSON.parse(this.encodeFilters ? atob(decodeURIComponent(this.getSearchParam(queryKey))) : this.getSearchParam(queryKey)) || {} : this.getSearchParam(null);
      } catch (e) {
        urlParams = {};
      }

      return {
        urlParams,
        queryKey
      };
    },

    initializeFilters() {
      const perPageValue = this.initialPerPageValue;
      let allInitialParams = { ...(this.defaultOrderBy && {
          'order_by': this.defaultOrderBy
        }),
        ...this.initFilters
      };

      if (perPageValue && this.$refs.table) {
        this.$refs.table.setLimit(parseInt(perPageValue));
      }

      if (!this.disableSearchParams) {
        const {
          urlParams
        } = this.getUrlParams();
        allInitialParams = { ...allInitialParams,
          ...urlParams
        };
      }

      Object.entries(allInitialParams).forEach(([parameter, value]) => {
        switch (parameter) {
          case 'order_by':
            const isDesc = value.startsWith('-');

            if (isDesc) {
              value = value.substr(1);
            }

            this.$refs.table.setOrder(value, !isDesc);
            break;

          default:
            parameter = parameter.replace('search_', '');

            if (this.tableColumns.includes(parameter) || this.forceFilter) {
              if (!this.disableSearchParams) {
                this.$set(this.options.urlFilters, parameter, value);
              }

              this.$refs.table.setFilter({
                [parameter]: value
              });
              this.$set(this.filterValues, parameter, value);
            }

        }
      });

      if (this.$refs.table) {
        if (!this.disableSearchParams && allInitialParams.page) {
          this.$refs.table.setPage(allInitialParams.page);
        } else {
          this.$refs.table.setPage(this.savedState ? this.savedState.page : this.initPage);
        }
      }
    },

    initTable() {
      this.hasRowTemplate = Object.keys(this.$scopedSlots).includes('row');

      if (this.url) {
        this.requestUrl = this.lazyTable && this.lazyTable.key ? `${this.url}?key=${this.lazyTable.key}` : `${this.url}`;

        if (this.shouldAllowRowSelection || this.keepId) {
          this.requestUrl += this.requestUrl.includes('?') ? '&keep_id=true' : '';
        }

        const lazyTableMarker = '/lazytable/';

        if (this.requestUrl.includes(lazyTableMarker)) {
          const params = new window.URLSearchParams(this.requestUrl.split(lazyTableMarker)[1]);
          this.lazyTableId = params.get('key') || this.lazyTable.key;
        }
      } else if (this.data) {
        this.count = this.data.length;
      }

      this.tableColumns.forEach(column => this.$set(this.visibleColumns, column, this.defaultColumnVisibility.length ? this.defaultColumnVisibility.includes(column) : true));
      this.tableColumns.forEach(column => this.$set(this.visibleColumns, column, this.hiddenColumns.length && this.hiddenColumns.includes(column) ? false : this.visibleColumns[column]));

      if (this.lazyTable.raw_table) {
        this.lazyTable.raw_table.columns.forEach(column => this.$set(this.sublevelVisibleColumns, column.name, this.defaultSublevelColumnVisibility.length ? this.defaultSublevelColumnVisibility.includes(column.name) : true));
      }

      if (this.shouldHideTable) return;

      if (!this.url) {
        this.isInitializing = false;
      }

      this.$nextTick(() => {
        this.initializeFilters();
        this.isInitializing = false;

        if (this.requestUrl && this.$refs.table) {
          this.$refs.table.getData();
        }
      });
      VueTables.Event.$on('vue-tables.loading', () => {
        if (!this.blockedLoading && !this.permanentlyBlockedLoading) {
          this.isLoadingTable = true;
        }
      });
      VueTables.Event.$on('vue-tables.loaded', () => {
        this.isLoadingTable = false;
        this.blockedLoading = false;
        this.$nextTick(() => {
          this.onPaginationData();
        });
      });
      VueTables.Event.$on('vue-tables.pagination', (state, data) => {
        this.currentPage = state;
        this.onPaginationCallback(state);
      });
    },

    getRowClasses(row) {
      const tableRef = this.$refs.table;
      const {
        openChildRows
      } = tableRef ? tableRef.$refs.table : [];
      return `${this.lazyTable.group_by_column && openChildRows.includes(row[this.lazyTable.group_by_column]) ? 'is_open' : ''} ${this.rowClassCallbackFunction(row)}`;
    },

    createOptions() {
      this.tableColumns = this.computedColumnsMeta.map(c => c.name);
      this.numericalColumns = this.computedColumnsMeta.map(columnData => {
        if (['int64', 'float64'].includes(columnData.type)) return columnData.name;
      }).filter(col => col);
      this.numericalColumns = [...this.numericalColumns, ...this.addNumericalColumns];
      if (this.shouldAllowRowSelection && !this.tableColumns.includes('_id')) this.tableColumns.unshift('_id');
      if (this.externalColumns) this.tableColumns = [...this.tableColumns, ...this.externalColumns];
      const currentTableSettings = this.settings && this.settings.details ? this.settings.details : this.settings;
      let columnsClasses = {
        'child_row': 'shrink-size',
        '_id': 'shrink-size'
      };
      this.numericalColumns.forEach(column => {
        columnsClasses[column] = 'is-numerical-column ';
      });
      this.options = {
        saveState: this.tableName && this.saveState,
        perPageValues: this.perPageValues,
        perPage: this.disablePagination ? 9999 : this.defaultPerPage || this.perPageValues[0],
        filterable: this.filterable,
        urlFilters: {},
        initFilters: this.initFilters,
        filterByColumn: this.filterable,
        filterAlgorithm: this.filterAlgorithm,
        sortable: this.tableColumns.filter(column => column !== 'actions' && (!this.sortExcludeColumns || this.sortExcludeColumns.indexOf(column) === -1)),
        headings: this.computedHeadings,
        sortIcon: {
          base: "fa",
          is: "fa-sort",
          up: "fa-sort-asc",
          down: "fa-sort-desc"
        },
        cellClassesCallbacks: this.cellClasses,
        columnsClasses,
        rowClassCallback: row => this.getRowClasses(row),
        listColumns: {
          "role.name": [{
            id: 1,
            text: "administrator"
          }, {
            id: 2,
            text: "default"
          }]
        },
        pagination: {
          edge: true
        },
        debounce: 250,
        requestFunction: async query => {
          if (!this.disablePagination) localStorage.setItem(this.perPageLocalStorageAccessor, query.limit);
          if (this.selectedRows.length && this.wasRowsSelectionExecuted) query['search_id__in'] = this.selectedRows.map(row => row[this.selectionColumn]);
          if (this.isInitializing) return;
          const {
            queryKey
          } = this.getUrlParams();
          let queryParams = { ...query.query
          };
          delete query.query;
          queryParams = { ...queryParams,
            ...query
          };
          this.clearAllFilters(queryKey);
          const orderBy = query.ascending === 1 ? queryParams.orderBy : `-${queryParams.orderBy}`;
          delete queryParams.ascending;
          const nonSearchParameters = [...Object.keys(queryParamsFlaskMap), ...Object.values(queryParamsFlaskMap), 'page', 'byColumn'];
          Object.entries(queryParams).forEach(([key, value]) => {
            delete queryParams[key];
            let queryKey = key;

            if (!nonSearchParameters.includes(key) && !key.startsWith('search_') && key !== 'key') {
              queryKey = `search_${key}`;
              this.$set(this.options.urlFilters, key.split('.')[0], value);
            }

            if (queryParamsFlaskMap[key]) queryKey = queryParamsFlaskMap[key];
            this.updateQuery(queryKey, value);
          });
          this.updateQuery('order_by', orderBy);
          if (!this.tableQuery.per_page) this.updateQuery('per_page', this.initialPerPageValue);
          this.clearSearchParams();
          const tableFilters = this.encodeFilters ? encodeURIComponent(btoa(JSON.stringify(this.tableQuery))) : JSON.stringify(this.tableQuery);
          this.setSearchParam(queryKey, tableFilters);
          const queryString = `${queryKey}=${tableFilters}${this.useOnlySpecifiedColumns ? `&columns=${this.tableColumns}` : ''}`;
          const queryURL = this.requestUrl.includes('?') ? `${this.requestUrl}&${queryString}` : `${this.requestUrl}?${queryString}`;
          this.queryString = `?${JSON.stringify(this.tableQuery)}`;
          let headers = {};
          const accessToken = localStorage.getItem('access_token');

          if (accessToken) {
            headers.authorization = `${this.tokenBearer} ${accessToken}`;
          }

          this.setCurrentFilterValues();
          const engagementID = this.$route && this.$route.params ? this.$route.params.engagementName || this.$route.params.engagementId || null : null;
          const res = await fetch(`${queryURL}${engagementID ? `&engagement_id=${engagementID}` : ''}`, {
            credentials: "same-origin",
            headers
          }).catch(e => {
            console.error("table-component error", e);
          });
          if (res.status !== 200) this.handleRequestError(res);
          let count = 0;
          let data = [];

          try {
            res.headers.forEach((value, header) => header === "x-pagination-total" ? count = value : null);
            data = await res.json();

            if (this.onResult) {
              this.onResult(data, this.tableQuery, count);
            }

            if (this.shouldSelectAllRows && this.enableSelectAllRowsOnServerTable) {
              data.forEach(row => {
                if (!this.selectedRows.find(selectedRow => selectedRow[this.selectionColumn] === row[this.selectionColumn])) {
                  this.selectedRows.push(row);
                }
              });
            }

            if (this.lazyTable.group_by_column) this.handleGroupByColumnResults(data);
          } catch (e) {
            console.error("table-component error", e);
          }

          return new Promise(resolve => {
            resolve({
              data,
              count
            });
            this.totalNumberOfRecords = count;
          });
        },
        texts: this.computedTableTexts,
        ...currentTableSettings
      };
      if (this.lazyTable.group_by_column) this.options.uniqueKey = this.lazyTable.group_by_column;else if (this.clientTableGroupByColumn) this.options.clientTableGroupByColumn = this.lazyTable.group_by_column;else if (this.externalGroupByColumn) this.options.uniqueKey = this.externalGroupByColumn;else this.options.showChildRowToggler = false;
    },

    permanentlyBlockLoading() {
      this.permanentlyBlockedLoading = true;
    },

    stopPermanentlyBlockLoading() {
      this.permanentlyBlockedLoading = false;
    },

    blockLoading() {
      this.blockedLoading = true;
    },

    setPerPageValue(perPageValue) {
      this.deSelectAllRows(false);
      this.$refs.table.setLimit(perPageValue);
      this.updateQuery("per_page", perPageValue);
      if (!this.disablePagination) localStorage.setItem(this.perPageLocalStorageAccessor, perPageValue);
    },

    getSearchParam(key = null) {
      const params = this.$route.query;
      if (!key) return params;
      return params[key] || null;
    },

    setSearchParam(key, value) {
      if (!this.$route.query || !key || this.disableSearchParams) {
        return;
      }

      const scrollPosition = window.scrollY;

      if (value === undefined || value === null) {
        if (this.$route && this.$route.query && this.$route.query[key]) {
          let queryCopy = { ...this.$route.query
          };
          delete queryCopy[key];
          this.$router.replace({
            query: queryCopy
          });
        }
      } else {
        if (this.$route && this.$route.query) {
          this.$router.replace({
            query: { ...this.$route.query,
              [key]: value
            }
          });
        }
      }

      this.$nextTick(() => window.scrollTo(0, scrollPosition));
    },

    clearSearchParams() {
      if (this.disableSearchParams) {
        return;
      }

      Object.entries(this.$route.query).forEach(([value, parameter]) => {
        if (parameter.includes('search_')) {
          this.setSearchParam(parameter, null);
        }
      });
    },

    onPaginationData() {
      const tableComponentTable = this.$refs.table;

      if (!tableComponentTable) {
        return;
      }

      const table = tableComponentTable.$refs.table;

      if (!table) {
        return;
      }

      const page = table.page;
      this.count = table.count;
      this.currentTableCount = table.count;
      this.totalPages = table.totalPages;
      const perPage = parseInt(this.selectedPerPageValue);
      const from = (page - 1) * perPage + 1;
      const to = page * perPage;
      const toText = to > table.count ? table.count : to;
      this.$emit("count-change", table.count);
      const type = this.totalPages <= 1 ? 1 : this.count === 0 ? 2 : 0;
      this.paginationText = this.replaceCounterValues(type, from, this.count, toText, this.count);
    },

    async checkExportProgress(taskId) {
      let headers = {};
      const accessToken = localStorage.getItem('access_token');

      if (accessToken) {
        headers.authorization = `Bearer ${accessToken}`;
      }

      const res = await fetch(`${this.apiUrl}api/tasks/${taskId}`, {
        credentials: 'same-origin',
        headers
      });
      const {
        result,
        status
      } = await res.json();

      if (['SUCCESS', 'FAILURE'].includes(status)) {
        this.lazyTableExportGenerating = false;

        if (status === 'SUCCESS') {
          this.lazyTableExportExists = true;
          this.lazyTableExportFilename = result;
          this.sendAnalyticsAction({
            file_name: this.lazyTableExportFilename
          }, this.$route);
        } else {
          alert(this.t('Export failed'));
        }
      } else {
        setTimeout(() => this.checkExportProgress(taskId), 1000);
      }
    },

    async generateLazyTableExport() {
      this.lazyTableExportGenerating = true;
      const queryString = JSON.stringify(this.tableQuery);
      const shouldExportSpecifiedColumns = this.exportColumns.length > 0;
      const headers = {
        'Content-Type': 'application/json'
      };
      const accessToken = localStorage.getItem('access_token');

      if (accessToken) {
        headers.authorization = `${this.tokenBearer} ${accessToken}`;
      }

      const {
        queryKey
      } = this.getUrlParams();
      const engagementID = this.$route && this.$route.params ? this.$route.params.engagementName || this.$route.params.engagementId || null : null;
      const res = await fetch(`${this.tableExportUrl}/?${queryKey}=${encodeURIComponent(this.encodeFilters ? btoa(queryString) : queryString)}&key=${this.lazyTableId}${engagementID ? `&engagement_id=${engagementID}` : ''}`, {
        credentials: 'same-origin',
        method: 'POST',
        body: JSON.stringify({
          renamer: this.replaceColumnValues,
          headings: this.computedHeadings,
          columns: shouldExportSpecifiedColumns ? this.exportColumns : this.exportVisibleColumnsOnly ? Object.keys(this.visibleColumns).filter(key => this.visibleColumns[key]) : this.tableColumns
        }),
        headers
      });
      const {
        task_id
      } = await res.json();
      this.onDownloadCallback(task_id);
      await this.checkExportProgress(task_id);
    },

    toggleColumnsModal() {
      this.columnsModalVisible = !this.columnsModalVisible;
    },

    toggleTableView() {
      this.detailOnly = !this.detailOnly;

      if (this.$refs.table) {
        this.$refs.table.setFilter('');
        this.$refs.table.options.urlFilters = {};
      }

      this.$nextTick(() => this.initializeFilters());
    },

    handleGroupByColumnResults(result) {
      this.selectedGroups = {};
      this.visibleRows = result;
    },

    toggleAllChildRows() {
      const tableRef = this.$refs.table;
      const {
        openChildRows
      } = tableRef.$refs.table;
      const openLength = openChildRows.length;
      this.visibleRows.forEach(row => {
        const rowKey = row[this.lazyTable.group_by_column];
        if (this.shouldCollapseChildRows && openChildRows.includes(rowKey)) tableRef.toggleChildRow(rowKey);else if (!this.shouldCollapseChildRows && (!openLength || !openChildRows.includes(rowKey))) {
          tableRef.toggleChildRow(rowKey);
        }
      });
      this.shouldCollapseChildRows = !this.shouldCollapseChildRows;
    },

    getDetailFilter(activeValue) {
      return {
        [this.lazyTable.group_by_column]: `^${activeValue ? activeValue : 'nan'}$`
      };
    },

    async downloadExport() {
      let ext = '';
      const engagementID = this.$route && this.$route.params ? this.$route.params.engagementName || this.$route.params.engagementId || null : null;
      const headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache"
      };
      const accessToken = localStorage.getItem("access_token");

      if (accessToken) {
        headers.authorization = `${this.tokenBearer} ${accessToken}`;
      }

      const response = await fetch(`${this.tableExportUrl}${this.exportUrl ? '' : '/'}${engagementID ? `?engagement_id=${engagementID}` : ''}`, {
        headers
      });
      if (response.status !== 200) return alert(this.t("File not found"), {
        mzToast: {
          color: "error",
          store: this.$store
        }
      });
      const fileResponse = await response.blob();
      if (!fileResponse) return alert(this.t("Something went wrong"), {
        mzToast: {
          color: "error",
          store: this.$store
        }
      });
      const objectUrl = window.URL.createObjectURL(fileResponse);
      const anchor = document.createElement("a");
      document.body.appendChild(anchor);
      const headerFileName = response.headers.get('content-disposition');

      if (headerFileName) {
        try {
          ext = headerFileName.match(/filename="(.+)"/)[1].split('.');
          ext = "." + ext.slice(2).join(".");
        } catch {
          ext = '.xlsx';
        }
      }

      const downloadFileName = `${this.exportFilename}${this.exportFilename.endsWith(ext) ? '' : ext}`;
      const timestamp = moment().format('YYYY-MM-DD-HH-mm');
      anchor.download = downloadFileName.replace(ext, `_${timestamp}${ext}`);
      anchor.href = objectUrl;
      anchor.click();
      window.URL.revokeObjectURL(objectUrl);
      anchor.remove();
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "relative w-100",
    class: {
      'hide-table-filters': _vm.shouldHideTableFilters,
      'shrink-child-row-selector': _vm.lazyTable && _vm.lazyTable.group_by_column
    },
    staticStyle: {
      "min-height": "200px"
    }
  }, [_vm.isLoadingTable ? _c('div', {
    staticClass: "loading-dots-container"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('Loading table data')))])]) : _vm._e(), _vm._v(" "), !_vm.shouldHideTable ? _c('div', {
    staticClass: "vue-table-wrapper",
    class: (_obj = {
      'vue-table-cards': _vm.theme === 'cards',
      'vue-table-row-template': _vm.hasRowTemplate,
      'vue-table-opacity': _vm.isLoadingTable
    }, _obj[this.addTableClasses] = true, _obj)
  }, [_c('div', {
    staticClass: "d-flex align-items-center buttons-row",
    class: {
      'vue-table-opacity': _vm.isLoadingTable
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between w-100",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm.shouldAllowRowSelection ? _c('div', {
    staticClass: "d-flex align-items-center buttons-row"
  }, [_c('CDropdown', {
    staticClass: "mr-2 d-flex align-items-baseline text-center dropdown-check-input",
    attrs: {
      "disabled": _vm.disableRowSelection
    },
    scopedSlots: _vm._u([{
      key: "toggler",
      fn: function () {
        return [_c('div', {
          staticClass: "border border-primary text-primary d-flex align-items-center justify-content-between px-2",
          staticStyle: {
            "width": "54px",
            "height": "48px"
          }
        }, [_c('CInputCheckbox', {
          attrs: {
            "data-cy": "select-multiple-dropdown",
            "custom": true,
            "checked": _vm.selectedRows.length !== 0,
            "disabled": _vm.disableRowSelection
          }
        }), _vm._v(" "), _c('i', {
          class: _vm.selectedRows.length !== 0 ? 'fa fa-chevron-up' : 'fa fa-chevron-down',
          staticStyle: {
            "margin-top": "2px"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2169033186)
  }, [_vm._v(" "), !_vm.url || _vm.enableSelectAllRowsOnServerTable ? _c('CDropdownItem', {
    attrs: {
      "data-cy": "select-all-items"
    },
    on: {
      "click": function ($event) {
        return _vm.selectAllRows();
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('Select all items')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('CDropdownItem', {
    on: {
      "click": _vm.selectVisibleRows
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('Select')) + "  \n              "), _c('span', [_vm._v(_vm._s(_vm.selectedPerPageValue > _vm.currentTableCount ? _vm.currentTableCount : _vm.selectedPerPageValue))]), _vm._v("\n                " + _vm._s(_vm.t('items from this page')) + "\n            ")]), _vm._v(" "), _c('CDropdownDivider'), _vm._v(" "), _c('CDropdownItem', {
    on: {
      "click": function () {
        return _vm.deSelectAllRows();
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('Deselect all items')) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    on: {
      "mousedown": function ($event) {
        return _vm.$emit('row-selection-action', _vm.selectedRows);
      }
    }
  }, [_vm._t("row-selection-button", [_c('CButton', {
    staticClass: "mz-button",
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "size": "sm",
      "color": "primary",
      "disabled": !_vm.selectedRows.length
    },
    on: {
      "click": _vm.handleSelectRowsAction
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.t(_vm.rowSelectionButtonText)) + " "), _c('br'), _vm._v("\n                  " + _vm._s(_vm.selectedRows.length) + " " + _vm._s(_vm.t('lines selected')) + "\n              ")])])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center ml-auto"
  }, [_vm.showTopNumberOfRecords && _vm.url && !_vm.detailOnly && _vm.showNumberOfLines && _vm.paginationTextPosition === 'top' ? _c('div', {
    staticClass: "d-flex align-items-center ml-1 btn-sm number-of-records"
  }, [_vm._v("\n              " + _vm._s(_vm.paginationText) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center relative"
  }, [!_vm.detailOnly && _vm.lazyTable.group_by_column ? _c('CButton', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.toggleAllChildRows
    }
  }, [!_vm.shouldCollapseChildRows ? _c('span', [_c('i', {
    staticClass: "fas fa-chevron-double-down"
  }), _vm._v("\n                " + _vm._s(_vm.t('Expand all')) + "\n              ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-chevron-double-up"
  }), _vm._v("\n                " + _vm._s(_vm.t('Collapse all')) + "\n              ")])]) : _vm._e(), _vm._v(" "), !_vm.detailOnly && _vm.theme !== 'cards' && _vm.displayColumnsSelector ? _c('CDropdown', {
    staticClass: "columns-dropdown",
    style: _vm.lazyTable.group_by_column || !_vm.lazyTable.raw_table ? '' : {
      'margin-right': '100px'
    },
    scopedSlots: _vm._u([{
      key: "toggler",
      fn: function () {
        return [_c('CButton', {
          attrs: {
            "size": "sm"
          },
          on: {
            "click": _vm.toggleColumnsModal
          }
        }, [_c('i', {
          staticClass: "fas fa-columns"
        }), _vm._v("\n                  " + _vm._s(_vm.t('Columns')) + "\n                ")])];
      },
      proxy: true
    }], null, false, 390657769)
  }, [_vm._v(" "), _c('div', {
    staticClass: "px-2 relative"
  }, [_c('div', {
    staticClass: "d-flex align-items-center gap-2 justify-content-end"
  }, [_c('span', {
    staticClass: "reset-columns-button link",
    on: {
      "click": function () {
        return _vm.resetVisibleColumns(false);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.t('Unselect all')) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "reset-columns-button link",
    on: {
      "click": function () {
        return _vm.resetVisibleColumns(true);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.t('Reset columns to default')) + "\n                  ")])]), _vm._v(" "), _c('CTabs', {
    staticClass: "mz-tabs px-3 pb-2",
    attrs: {
      "addNavClasses": "d-flex flex-nowrap text-nowrap sublevel-columns-nav-styling"
    }
  }, [_c('CTab', {
    attrs: {
      "title": _vm.t('First level')
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap text-capitalize"
  }, _vm._l(_vm.tableColumns.filter(function (columnName) {
    return _vm.visibleColumnsFilters(columnName);
  }), function (column) {
    return _c('CInputCheckbox', {
      key: column,
      staticClass: "w-50 pr-3",
      staticStyle: {
        "flex-basis": "50%"
      },
      attrs: {
        "label": column && (_vm.computedHeadings[column] || column.replaceAll("_", " ")),
        "value": column,
        "checked": _vm.visibleColumns[column],
        "disabled": !!_vm.options.urlFilters[column],
        "custom": true
      },
      on: {
        "update:checked": function ($event) {
          return _vm.$set(_vm.visibleColumns, column, $event);
        }
      }
    });
  }), 1)]), _vm._v(" "), _vm.lazyTable.group_by_column ? _c('CTab', {
    attrs: {
      "title": _vm.t('Second level')
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap text-capitalize"
  }, _vm._l(_vm.lazyTable.raw_table.columns.filter(function (columnName) {
    return _vm.visibleColumnsFilters(columnName);
  }), function (column) {
    return _c('CInputCheckbox', {
      key: column.name,
      staticClass: "w-50 pr-3",
      staticStyle: {
        "flex-basis": "50%"
      },
      attrs: {
        "label": column.name && (_vm.computedHeadings[column.name] || column.name.replaceAll("_", " ")),
        "value": column.name,
        "custom": true,
        "checked": _vm.sublevelVisibleColumns[column.name],
        "disabled": _vm.lazyTable.group_by_column === column.name
      },
      on: {
        "update:checked": function ($event) {
          return _vm.$set(_vm.sublevelVisibleColumns, column.name, $event);
        }
      }
    });
  }), 1)]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _vm.lazyTable.group_by_column ? _c('CButton', {
    style: _vm.detailOnly ? {
      'position': 'absolute',
      'left': '-150px',
      'top': '-17px',
      'z-index': 5
    } : '',
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.toggleTableView
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fas fa-exchange-alt mr-1"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.t((_vm.detailOnly ? 'Grouped' : 'Line') + " view")))])])]) : _vm._e()], 1)])]), _vm._v(" "), _vm._t("export_btns", [_vm.canExportTable ? _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-1 file-button-container"
  }, [_vm.lazyTableExportExists && _vm.lazyTableExportFilename ? _c('span', {
    staticClass: "mr-3"
  }, [_vm._v("\n              " + _vm._s(_vm.t('You can now download the')) + " " + _vm._s(_vm.exportFilename) + " " + _vm._s(_vm.t('File')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm.lazyTableExportExists && _vm.lazyTableExportFilename ? _c('CButton', {
    directives: [{
      name: "c-tooltip",
      rawName: "v-c-tooltip",
      value: {
        content: _vm.t('Download generated excel file'),
        placement: 'top-end'
      },
      expression: "{\n              content: t('Download generated excel file'),\n              placement: 'top-end'\n            }"
    }],
    attrs: {
      "size": "sm",
      "variant": "outline",
      "color": "success"
    },
    on: {
      "click": _vm.downloadExport
    }
  }, [_c('i', {
    staticClass: "fas fa-folder-download"
  })]) : _vm.lazyTableExportGenerating ? _c('CButton', {
    directives: [{
      name: "c-tooltip",
      rawName: "v-c-tooltip",
      value: {
        content: _vm.t('Preparing file'),
        placement: 'top-end'
      },
      expression: "{\n              content: t('Preparing file'),\n              placement: 'top-end'\n            }"
    }],
    attrs: {
      "size": "sm",
      "variant": "outline",
      "color": "warning"
    }
  }, [_c('i', {
    staticClass: "fas fa-spinner spin-animation"
  })]) : !_vm.detailOnly ? _c('CButton', {
    directives: [{
      name: "c-tooltip",
      rawName: "v-c-tooltip",
      value: {
        content: _vm.t('Generate Excel/CSV File'),
        placement: 'top-end'
      },
      expression: "{\n              content: t('Generate Excel/CSV File'),\n              placement: 'top-end'\n            }"
    }],
    staticClass: "mz-icon-btn xs outline btn-radius",
    attrs: {
      "variant": "outline",
      "color": "primary"
    },
    on: {
      "click": _vm.generateLazyTableExport
    }
  }, [_c('em', {
    staticClass: "mz-icon icon-download-alt color-inherit"
  })]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _vm.showTopNumberOfRecords && _vm.data && !_vm.url && _vm.showNumberOfLines ? _c('div', {
    staticClass: "d-flex align-items-center ml-1 btn-sm number-of-records",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.paginationText) + "\n      ")]) : _vm._e()], 2), _vm._v(" "), _vm.defaultPerPageSelector ? _c('v-style', [_vm._v("\n      .VueTables .row .VueTables__limit {\n      display: none;\n      }\n    ")]) : _vm._e(), _vm._v(" "), parseInt(_vm.totalNumberOfRecords) <= parseInt(_vm.selectedPerPageValue) ? _c('v-style', [_vm._v("\n      .VueTables--server .VuePagination {\n      display: none !important;\n      }\n    ")]) : _vm._e(), _vm._v(" "), _vm.paginationBreakpoint ? _c('v-style', [_vm._v("\n      @media screen and (max-width: " + _vm._s(_vm.paginationBreakpoint) + "px) {\n      .VueTables .row {\n      right: 0;\n      bottom: -43px;\n      }\n      }\n    ")]) : _vm._e(), _vm._v(" "), _c('v-style', [_vm._v("\n      .VueTables__table tr.VueTables__filters-row th {\n      border-top: 1px solid #e1e2e3 !important;\n      border-bottom: 1px solid #e1e2e3 !important;\n      }\n    ")]), _vm._v(" "), _vm._l(_vm.computedColumnsMeta.map(function (c) {
    return c.name;
  }).concat(_vm.filterExcludeColumns || []), function (column) {
    return _c('v-style', [_vm._v("\n      input[name=\"vf__" + _vm._s(column) + "\"] {\n      display: none;\n      }\n    ")]);
  }), _vm._v(" "), _vm.disablePagination || !_vm.showPerPageSelector ? _c('v-style', [_vm._v("\n      .VueTables__limit {\n      display: none !important;\n      }\n    ")]) : _vm._e(), _vm._v(" "), _vm.color ? _c('v-style', [_vm._v("\n      #table-" + _vm._s(_vm.tableId) + " td {\n      border-color: var(--" + _vm._s(_vm.color) + ") !important;\n      }\n      #table-" + _vm._s(_vm.tableId) + " th {\n      background-color: var(--" + _vm._s(_vm.color) + ") !important;\n      color: var(--fullwhite) !important;\n      border-color: var(--dark-background) !important;\n      }\n    ")]) : _vm._e(), _vm._v(" "), _vm.requestUrl && !_vm.detailOnly ? _c('v-server-table', {
    key: _vm.shouldRefreshTable,
    ref: "table",
    attrs: {
      "url": _vm.requestUrl,
      "columns": _vm.columnsToDisplay,
      "options": _vm.options,
      "filterable": _vm.filterable,
      "name": _vm.tableName
    },
    scopedSlots: _vm._u([_vm._l(_vm.tableColumns, function (column) {
      return {
        key: column,
        fn: function (scope) {
          return !_vm.hasRowTemplate && !Object.keys(_vm.$scopedSlots).concat(Object.keys(_vm.$slots), ['_id']).includes(column) ? [_vm.rowLength(scope.row[column]) > 30 ? _c('div', {
            directives: [{
              name: "c-tooltip",
              rawName: "v-c-tooltip",
              value: _vm.getDisplayValue(scope.row[column], column),
              expression: "getDisplayValue(scope.row[column], column)"
            }],
            class: {
              'text-right': _vm.numericalColumns.includes(column)
            },
            staticStyle: {
              "width": "100%",
              "min-height": "1px"
            }
          }, [_vm.addCollapseCellValue.includes(column) ? _c('div', {
            staticClass: "d-flex flex-column"
          }, [_c('i', {
            staticClass: "fas fa-plus-circle ml-auto",
            on: {
              "click": function (e) {
                return _vm.handleCollapseRow(e);
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "text-overflow-ellipsis-table-row"
          }, [_vm._v("\n              " + _vm._s(_vm.getDisplayValue(scope.row[column], column)) + "\n            ")])]) : _c('span', [_vm._v("\n            " + _vm._s(_vm.getDisplayValue(scope.row[column], column)) + "\n          ")])]) : scope.row[column] ? _c('div', {
            class: {
              'text-right': _vm.numericalColumns.includes(column)
            },
            staticStyle: {
              "width": "100%",
              "min-height": "1px"
            }
          }, [_vm._v("\n          " + _vm._s(_vm.getDisplayValue(scope.row[column], column)) + "\n        ")]) : _c('div', [_vm._v("\n          -\n        ")])] : undefined;
        }
      };
    }), _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    }), {
      key: "_id",
      fn: function (ref) {
        var row = ref.row;
        return _vm.tableColumns.includes(_vm.selectionColumn) ? [_c('div', {
          staticClass: "w-100 d-flex align-items-center justify-content-center"
        }, [_c('CInputCheckbox', {
          key: row[_vm.selectionColumn],
          attrs: {
            "custom": true,
            "value": row[_vm.selectionColumn],
            "checked": !!_vm.selectedRows.find(function (selectedRow) {
              return selectedRow[_vm.selectionColumn] === row[_vm.selectionColumn];
            }),
            "disabled": _vm.disableRowSelection
          },
          on: {
            "input": function () {
              return _vm.handleRowSelection(row);
            }
          }
        })], 1)] : undefined;
      }
    }, {
      key: "child_row",
      fn: function (ref) {
        var row = ref.row;
        return _vm.lazyTable && _vm.lazyTable.group_by_column ? [_c('div', {
          staticClass: "nested-rows relative"
        }, [_vm._t("child_row", null, null, {
          row: row
        }), _vm._v(" "), _c('div', {
          staticClass: "border-filler"
        }), _vm._v(" "), _vm.lazyTable && _vm.lazyTable.raw_table && _vm.lazyTable.raw_table.key && _vm.lazyTable.group_by_column && !_vm.childRowOverwritten ? _c('tableComponent', {
          attrs: {
            "url": _vm.childUrl || _vm.url,
            "name": _vm.lazyTable.raw_table.key,
            "columns-meta": _vm.sublevelColumnsToDisplay,
            "lazy-table": _vm.lazyTable.raw_table,
            "filter-exclude-columns": _vm.lazyTable.raw_table.columns.map(function (c) {
              return c.name;
            }),
            "add-table-classes": "sublevel-scroll",
            "sort-exclude-columns": _vm.lazyTable.raw_table.columns.map(function (c) {
              return c.name;
            }),
            "force-filter": _vm.forceFilter,
            "init-filters": Object.assign({}, _vm.initFilters, _vm.getDetailFilter(row[_vm.lazyTable.group_by_column])),
            "default-order-by": _vm.sublevelOrderBy || _vm.defaultOrderBy,
            "show-top-number-of-records": false,
            "headings": _vm.headings,
            "notFormattedColumns": _vm.notFormattedColumns,
            "disableSearchParams": true
          }
        }) : _vm._e()], 2)] : undefined;
      }
    }], null, true)
  }, [_vm._l(_vm.computedColumnsMeta, function (column) {
    return [!(_vm.tableOverrideFilters[column.name] && _vm.tableOverrideFilters[column.name].filterComponent) ? [!(_vm.filterExcludeColumns || []).includes(column.name) ? _c('div', {
      staticClass: "d-flex flex-row align-items-center",
      class: _vm.isColumnNumerical(column) ? 'justify-content-end' : 'justify-content-center',
      attrs: {
        "slot": 'filter__' + column.name
      },
      slot: 'filter__' + column.name
    }, [!_vm.tableOverrideFilters[column.name] && column.type !== 'boolean' && _vm.showFilterHelp ? _c('i', {
      directives: [{
        name: "c-tooltip",
        rawName: "v-c-tooltip",
        value: {
          placement: 'left',
          html: true,
          container: false,
          appendToBody: true,
          content: _vm.getFilterDoc(column.type)
        },
        expression: "{\n                placement: 'left',\n                html: true,\n                container: false,\n                appendToBody: true,\n                content: getFilterDoc(column.type)\n              }"
      }],
      staticClass: "far fa-question-circle mt-1 d-flex align-items-center mr-2"
    }) : _vm._e(), _vm._v(" "), _vm.tableOverrideFilters[column.name] ? _c('div', [_c('MzSelect', {
      staticClass: "table-mz-select",
      attrs: {
        "options": _vm.getSelectOptions(column.name),
        "value": _vm.filterValues[column.name],
        "single-option-height": 24
      },
      on: {
        "update:value": [function ($event) {
          return _vm.$set(_vm.filterValues, column.name, $event);
        }, function (value) {
          return _vm.filterHandler(value, column.name);
        }],
        "cancel:filter": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      }
    })], 1) : column.type === 'boolean' ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('MzSelect', {
      staticClass: "table-mz-select",
      attrs: {
        "options": _vm.getSelectOptions(column.name, _vm.booleanFilterDefaultOptions),
        "value": _vm.filterValues[column.name],
        "single-option-height": 24
      },
      on: {
        "update:value": [function ($event) {
          return _vm.$set(_vm.filterValues, column.name, $event);
        }, function (value) {
          return _vm.filterHandler(value, column.name);
        }],
        "cancel:filter": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      }
    })], 1) : column.type === 'date' || column.type === 'datetime64[ns]' ? _c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "date-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      staticClass: "date-filter__input form-control mz-input flex-fill",
      attrs: {
        "placeholder": _vm.getFilterPlaceholder(column.name)
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.dateFilterHandler(e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-calendar-alt date-filter__toggler"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      staticClass: "date-filter__datepicker cursor-pointer",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.dateFilterHandler(e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    })])]) : column.type === 'date_range' ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [[_c('div', {
      staticClass: "date-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].startDate,
        expression: "dateRangeValues[column.name].startDate"
      }],
      staticClass: "date-filter__input form-control mz-input flex-fill",
      attrs: {
        "placeholder": _vm.t('From date')
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].startDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(e.target.value, undefined, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "startDate", $event.target.value);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-calendar-alt date-filter__toggler"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].startDate,
        expression: "dateRangeValues[column.name].startDate"
      }],
      staticClass: "date-filter__datepicker",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].startDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(e.target.value, undefined, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "startDate", $event.target.value);
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "date-filter ml-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].endDate,
        expression: "dateRangeValues[column.name].endDate"
      }],
      staticClass: "date-filter__input form-control mz-input flex-fill",
      attrs: {
        "placeholder": _vm.t('To date')
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].endDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(undefined, e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "endDate", $event.target.value);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-calendar-alt date-filter__toggler"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].endDate,
        expression: "dateRangeValues[column.name].endDate"
      }],
      staticClass: "date-filter__datepicker cursor-pointer",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].endDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(undefined, e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "endDate", $event.target.value);
        }
      }
    })])]], 2) : _vm.isColumnNumerical(column) ? _c('div', {
      staticClass: "d-flex align-items-end text-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      staticClass: "form-control mz-input text-right",
      style: _vm.options.urlFilters[column.name] ? 'border: 3px solid rgb(79, 123, 59); background-color: rgba(79, 123, 59, 0.2)' : '',
      attrs: {
        "placeholder": _vm.getFilterPlaceholder(column.name),
        "type": "text",
        "name": 'filter__' + column.name
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.inputFilterHandler(e, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    })]) : _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      staticClass: "form-control mz-input",
      style: _vm.options.urlFilters[column.name] ? 'border: 3px solid rgb(79, 123, 59); background-color: rgba(79, 123, 59, 0.2)' : '',
      attrs: {
        "placeholder": _vm.getFilterPlaceholder(column.name),
        "type": "text",
        "name": 'filter__' + column.name
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.inputFilterHandler(e, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    })]), _vm._v(" "), !_vm.tableOverrideFilters[column.name] && column.type !== 'boolean' && _vm.activeFilterList.find(function (filter) {
      return filter === column.name;
    }) ? _c('span', {
      directives: [{
        name: "c-tooltip",
        rawName: "v-c-tooltip",
        value: _vm.t('Clear'),
        expression: "t('Clear')"
      }],
      staticClass: "link clear-filter ml-2",
      on: {
        "click": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-filter mr-1"
    })]) : _vm._e()]) : _vm._e()] : column.filterComponent ? _c(column.filterComponent, _vm._b({
      tag: "component",
      attrs: {
        "slot": 'filter__' + column.name,
        "defaultValue": _vm.options.urlFilters[column.name]
      },
      on: {
        "update:filter": function (val) {
          var _obj;

          return _vm.$refs.table.setFilter((_obj = {}, _obj[column.name] = val, _obj));
        },
        "cancel:filter": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      },
      slot: 'filter__' + column.name
    }, 'component', column.filterComponentProps || {}, false)) : _vm._e()];
  }), _vm._v(" "), _vm._l(Object.keys(_vm.$slots), function (slot) {
    return _vm._t(slot, null, {
      "slot": slot
    });
  })], 2) : _vm.lazyTable && _vm.lazyTable.raw_table && _vm.lazyTable.raw_table.key && _vm.lazyTable.group_by_column && _vm.detailOnly ? _c('tableComponent', {
    staticClass: "table-details",
    attrs: {
      "url": _vm.childUrl || _vm.url,
      "force-filter": _vm.forceFilter,
      "lazy-table": _vm.lazyTable.raw_table,
      "init-filters": _vm.lineViewInitFilters,
      "default-column-visibility": _vm.defaultSublevelColumnVisibility,
      "filter-exclude-columns": _vm.filterExcludeColumns.concat(_vm.lineViewFilterExcludeColumns),
      "notFormattedColumns": _vm.notFormattedColumns
    },
    on: {
      "count-change": _vm.subTableDataCount
    }
  }) : _vm.data && !_vm.isInitializing ? _c('v-client-table', {
    ref: "table",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columnsToDisplay,
      "options": _vm.options,
      "filterable": _vm.filterable,
      "name": _vm.tableName
    },
    scopedSlots: _vm._u([_vm._l(_vm.tableColumns, function (column) {
      return {
        key: column,
        fn: function (scope) {
          return !_vm.hasRowTemplate && !Object.keys(_vm.$scopedSlots).concat(Object.keys(_vm.$slots), ['_id']).includes(column) ? [_vm.rowLength(scope.row[column]) > 30 ? _c('div', {
            directives: [{
              name: "c-tooltip",
              rawName: "v-c-tooltip",
              value: _vm.getDisplayValue(scope.row[column], column),
              expression: "getDisplayValue(scope.row[column], column)"
            }],
            staticClass: "text-overflow-ellipsis-table-row",
            class: {
              'text-right': _vm.numericalColumns.includes(column)
            },
            staticStyle: {
              "width": "100%",
              "min-height": "1px"
            }
          }, [_vm._v("\n          " + _vm._s(_vm.getDisplayValue(scope.row[column], column)) + "\n        ")]) : scope.row[column] ? _c('div', {
            class: {
              'text-right': _vm.numericalColumns.includes(column)
            },
            staticStyle: {
              "width": "100%",
              "min-height": "1px"
            }
          }, [_vm._v("\n          " + _vm._s(_vm.getDisplayValue(scope.row[column], column)) + "\n        ")]) : _c('div', [_vm._v("\n          -\n        ")])] : undefined;
        }
      };
    }), _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    }), {
      key: "_id",
      fn: function (ref) {
        var row = ref.row;
        return _vm.tableColumns.includes(_vm.selectionColumn) ? [_c('div', {
          staticClass: "w-100 d-flex align-items-center justify-content-center"
        }, [_c('CInputCheckbox', {
          key: row[_vm.selectionColumn],
          attrs: {
            "custom": true,
            "value": row[_vm.selectionColumn],
            "checked": !!_vm.selectedRows.find(function (selectedRow) {
              return selectedRow[_vm.selectionColumn] === row[_vm.selectionColumn];
            }),
            "disabled": _vm.disableRowSelection
          },
          on: {
            "input": function () {
              return _vm.handleRowSelection(row);
            }
          }
        })], 1)] : undefined;
      }
    }], null, true)
  }, [_vm._l(_vm.computedColumnsMeta, function (column) {
    return [!(_vm.tableOverrideFilters[column.name] && _vm.tableOverrideFilters[column.name].filterComponent) ? [!(_vm.filterExcludeColumns || []).includes(column.name) ? _c('div', {
      staticClass: "d-flex mb-2",
      class: _vm.isColumnNumerical(column) ? 'flex-row-reverse' : 'flex-row',
      attrs: {
        "slot": 'filter__' + column.name
      },
      slot: 'filter__' + column.name
    }, [!_vm.tableOverrideFilters[column.name] && column.type !== 'boolean' && _vm.showFilterHelp ? _c('i', {
      directives: [{
        name: "c-tooltip",
        rawName: "v-c-tooltip",
        value: {
          placement: 'left',
          html: true,
          container: false,
          appendToBody: true,
          content: _vm.getFilterDoc(column.type, 'client')
        },
        expression: "{\n                placement: 'left',\n                html: true,\n                container: false,\n                appendToBody: true,\n                content: getFilterDoc(column.type, 'client')\n              }"
      }],
      staticClass: "far fa-question-circle mt-1 d-flex align-items-center",
      class: _vm.isColumnNumerical(column) ? 'ml-2' : 'mr-2'
    }) : _vm._e(), _vm._v(" "), _vm.tableOverrideFilters[column.name] ? _c('div', [_c('MzSelect', {
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      staticClass: "table-mz-select",
      attrs: {
        "options": _vm.getSelectOptions(column.name),
        "value": _vm.filterValues[column.name],
        "single-option-height": 24
      },
      on: {
        "update:value": [function ($event) {
          return _vm.$set(_vm.filterValues, column.name, $event);
        }, function (value) {
          return _vm.filterHandler(value, column.name);
        }],
        "cancel:filter": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      }
    })], 1) : column.type === 'boolean' ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('MzSelect', {
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      staticClass: "table-mz-select",
      attrs: {
        "options": _vm.getSelectOptions(column.name, _vm.booleanFilterDefaultOptions),
        "value": _vm.filterValues[column.name],
        "single-option-height": 24
      },
      on: {
        "update:value": [function ($event) {
          return _vm.$set(_vm.filterValues, column.name, $event);
        }, function (value) {
          return _vm.filterHandler(value, column.name);
        }],
        "cancel:filter": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      }
    })], 1) : column.type === 'date' || column.type === 'datetime64[ns]' ? _c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "date-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      staticClass: "date-filter__input form-control mz-input flex-fill",
      attrs: {
        "placeholder": _vm.getFilterPlaceholder(column.name)
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.dateFilterHandler(e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-calendar-alt date-filter__toggler"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      key: column.name + "_filter_datepicker_" + _vm.shouldRefreshTable,
      staticClass: "date-filter__datepicker cursor-pointer",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.dateFilterHandler(e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    })])]) : column.type === 'date_range' ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [[_c('div', {
      staticClass: "date-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].startDate,
        expression: "dateRangeValues[column.name].startDate"
      }],
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      staticClass: "date-filter__input form-control mz-input flex-fill",
      attrs: {
        "placeholder": _vm.t('From date')
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].startDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(e.target.value, undefined, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "startDate", $event.target.value);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-calendar-alt date-filter__toggler"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].startDate,
        expression: "dateRangeValues[column.name].startDate"
      }],
      key: column.name + "_filter_datepicker_" + _vm.shouldRefreshTable,
      staticClass: "date-filter__datepicker",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].startDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(e.target.value, undefined, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "startDate", $event.target.value);
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "date-filter ml-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].endDate,
        expression: "dateRangeValues[column.name].endDate"
      }],
      key: column.name + "_filter_to_" + _vm.shouldRefreshTable,
      staticClass: "date-filter__input form-control mz-input flex-fill",
      attrs: {
        "placeholder": _vm.t('To date')
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].endDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(undefined, e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "endDate", $event.target.value);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-calendar-alt date-filter__toggler"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.dateRangeValues[column.name].endDate,
        expression: "dateRangeValues[column.name].endDate"
      }],
      key: column.name + "_filter_to_datepicker_" + _vm.shouldRefreshTable,
      staticClass: "date-filter__datepicker cursor-pointer",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm.dateRangeValues[column.name].endDate
      },
      on: {
        "change": function (e) {
          return _vm.dateRangeFilterHandler(undefined, e.target.value, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.dateRangeValues[column.name], "endDate", $event.target.value);
        }
      }
    })])]], 2) : _vm.isColumnNumerical(column) ? _c('div', {
      staticClass: "d-flex align-items-end text-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      staticClass: "form-control mz-input text-right",
      style: _vm.options.urlFilters[column.name] ? 'border: 3px solid rgb(79, 123, 59); background-color: rgba(79, 123, 59, 0.2)' : '',
      attrs: {
        "placeholder": _vm.getFilterPlaceholder(column.name),
        "type": "text",
        "name": 'filter__' + column.name
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.inputFilterHandler(e, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    })]) : _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.filterValues[column.name],
        expression: "filterValues[column.name]"
      }],
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      staticClass: "form-control mz-input",
      style: _vm.options.urlFilters[column.name] ? 'border: 3px solid rgb(79, 123, 59); background-color: rgba(79, 123, 59, 0.2)' : '',
      attrs: {
        "placeholder": _vm.getFilterPlaceholder(column.name),
        "type": "text",
        "name": 'filter__' + column.name
      },
      domProps: {
        "value": _vm.filterValues[column.name]
      },
      on: {
        "change": function (e) {
          return _vm.inputFilterHandler(e, column.name);
        },
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.filterValues, column.name, $event.target.value);
        }
      }
    })]), _vm._v(" "), !_vm.tableOverrideFilters[column.name] && column.type !== 'boolean' && _vm.activeFilterList.find(function (filter) {
      return filter === column.name;
    }) ? _c('span', {
      directives: [{
        name: "c-tooltip",
        rawName: "v-c-tooltip",
        value: _vm.t('Clear'),
        expression: "t('Clear')"
      }],
      staticClass: "link clear-filter ml-2",
      on: {
        "click": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-filter mr-1"
    })]) : _vm._e()]) : _vm._e()] : column.filterComponent ? _c(column.filterComponent, _vm._b({
      key: column.name + "_filter_" + _vm.shouldRefreshTable,
      tag: "component",
      attrs: {
        "slot": 'filter__' + column.name,
        "defaultValue": _vm.options.urlFilters[column.name]
      },
      on: {
        "update:filter": function (val) {
          var _obj;

          return _vm.$refs.table.setFilter((_obj = {}, _obj[column.name] = val, _obj));
        },
        "cancel:filter": function () {
          return _vm.filterHandler(null, column.name, column.type);
        }
      },
      slot: 'filter__' + column.name
    }, 'component', column.filterComponentProps || {}, false)) : _vm._e()];
  }), _vm._v(" "), _vm._l(Object.keys(_vm.$slots), function (slot) {
    return _vm._t(slot, null, {
      "slot": slot
    });
  })], 2) : _vm._e(), _vm._v(" "), !_vm.defaultPerPageSelector && _vm.count > _vm.perPageValues[0] ? _c('div', {
    staticClass: "pagination-container"
  }) : _vm._e(), _vm._v(" "), _vm.showTopNumberOfRecords && _vm.url && !_vm.detailOnly && _vm.showNumberOfLines && _vm.paginationTextPosition === 'bottom' ? _c('div', {
    staticClass: "d-flex align-items-center ml-1 btn-sm number-of-records"
  }, [_vm._v("\n        " + _vm._s(_vm.paginationText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.defaultPerPageSelector && _vm.count > _vm.perPageValues[0] ? _c('div', {
    staticClass: "per-page-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('Show')))]), _vm._v(" "), _c('select', {
    staticClass: "table-select form-control",
    attrs: {
      "name": "per-page-select"
    },
    on: {
      "change": function ($event) {
        return _vm.setPerPageValue($event.target.value);
      }
    }
  }, _vm._l(_vm.perPageValues, function (value) {
    return _c('option', {
      domProps: {
        "value": value,
        "selected": value == _vm.selectedPerPageValue
      }
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")]);
  }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.t('results per page')))])]) : _vm._e()], 2) : _c('div', [_vm.lazyTableId && _vm.showGenerateExcelBtn ? _c('div', {
    staticClass: "px-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_vm.lazyTableExportExists && _vm.lazyTableExportFilename ? _c('a', {
    directives: [{
      name: "c-tooltip",
      rawName: "v-c-tooltip",
      value: {
        content: _vm.t('Download generated excel file'),
        placement: 'top-end'
      },
      expression: "{\n            content: t('Download generated excel file'),\n            placement: 'top-end'\n          }"
    }],
    on: {
      "click": _vm.downloadExport
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('Download')) + " " + _vm._s(_vm.downloadFileName) + "\n        ")]) : _vm.lazyTableExportGenerating ? _c('span', {
    directives: [{
      name: "c-tooltip",
      rawName: "v-c-tooltip",
      value: {
        content: _vm.t('Preparing file'),
        placement: 'top-end'
      },
      expression: "{\n            content: t('Preparing file'),\n            placement: 'top-end'\n          }"
    }]
  }, [_vm._v("\n          " + _vm._s(_vm.t('Generating')) + " " + _vm._s(_vm.downloadFileName) + "\n        ")]) : _c('span', {
    directives: [{
      name: "c-tooltip",
      rawName: "v-c-tooltip",
      value: {
        content: _vm.t('Generate Excel/CSV File'),
        placement: 'top-end'
      },
      expression: "{\n            content: t('Generate Excel/CSV File'),\n            placement: 'top-end'\n          }"
    }],
    on: {
      "click": _vm.generateLazyTableExport
    }
  }, [_vm._v("\n          " + _vm._s(_vm.downloadFileName) + "\n        ")])])]) : _vm._e()])]);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "dot-animated"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-animated"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot-animated"
  })]);
}];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-575abd56_0", {
    source: "@charset \"UTF-8\";.VueTables .table-responsive{padding-bottom:6rem!important;margin-bottom:-6rem!important;overflow-x:auto;overflow-y:hidden}.VueTables .table-responsive .VueTables__table{overflow:unset!important}.mz-table>thead>tr>th{padding:4px 20px!important}.VueTables .mz-table th,.VueTables .mz-table tr{border:none!important}.mz-table>thead>tr>th div .mz-select{min-width:130px!important}.mz-table>thead>tr>th div .mz-options{display:flex;flex-direction:column!important;max-height:150px!important}.VueTables__row>td{position:relative}.VueTables__row>td:focus-within{z-index:3}.vt-per-page-wrapper{gap:5px}.vt-per-page-wrapper .mz-select-wrapper{margin:0}.date-filter{position:relative;display:flex;flex-wrap:nowrap;gap:.5rem;align-items:center}.date-filter__input{width:5.5rem;padding-right:4px;z-index:2}.date-filter__toggler{position:relative;font-size:1rem;cursor:pointer}.date-filter__datepicker{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;float:right;cursor:pointer;box-sizing:border-box}.number-of-records{gap:4px}.row-count{font-weight:700;font-size:120%;line-height:1.4}.reset-columns-button{top:0;right:1rem}.sublevel-columns-nav-styling{padding-right:200px}.sublevel-columns-nav-styling li{padding-top:0!important}.text-overflow-ellipsis-table-row{overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.mz-table>tbody>tr>td{vertical-align:middle!important;padding:5px 21px!important}.border-filler{position:absolute;bottom:-3px;left:-3px;width:3px;height:3px;background:#fff}.VueTables__table.mz-table>tbody tr.VueTables__child-row.is_open>td{padding:12px 0 0 0!important}.shrink-size{width:10px!important;padding:5px 0!important}.shrink-child-row-selector .nested-rows .VueTables__table.mz-table>thead tr>th:first-child{width:auto!important}.nested-rows table.mz-table{table-layout:fixed;padding-left:1rem}.sublevel-scroll{overflow-x:auto;max-width:100%}.sublevel-scroll .table-responsive table{table-layout:auto!important}.loading-dots-container{position:absolute!important;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);width:100%;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;margin:0!important;z-index:500}.dot{height:10px;width:10px;border-radius:50%;display:inline-block}.dot-animated{background:var(--success);height:10px;width:10px;border-radius:50%;display:inline-block;animation:jump 1.4s infinite}.dot-animated:nth-child(2){background:var(--primary);animation-delay:.2s}.dot-animated:nth-child(3){background:var(--warning);animation-delay:.4s}.vue-table-opacity,.vue-table-opacity .VueTables{opacity:40%!important}.VueTables__child-row-toggler{width:16px;height:16px;line-height:16px;display:block;margin:auto;text-align:center}.VueTables__child-row-toggler--closed::before{font-family:\"Font Awesome 5 Pro\",\"Font Awesome 5 Free\";content:\"\";font-weight:900}.VueTables__child-row-toggler--open::before{font-family:\"Font Awesome 5 Pro\",\"Font Awesome 5 Free\";content:\"\";font-weight:900}.VueTables__child-row .buttons-row,.VueTables__child-row .per-page-wrapper{display:none!important}.VueTables__child-row .table-responsive{padding-bottom:0!important;margin-bottom:0!important}.spin-animation{animation:spin 3s linear infinite}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.VuePagination__count,.VueTables__search{display:none!important}.VueTables__table th{vertical-align:middle!important}.VueTables__table th .VueTables__sort-icon,.VueTables__table th .VueTables__sort-icon.float-right{margin-left:20px;float:unset!important}.VueTables__limit{display:block}.pagination-container{display:block;height:50px}.VueTables{display:flex;flex-direction:column;align-items:center}.VueTables .mz-pagination{position:absolute;bottom:-3px;right:0}.VueTables .row{position:absolute;bottom:0;right:350px}.VueTables .row .VueTables__limit{margin-bottom:10px}.VuePagination{position:relative!important;line-height:16px;z-index:1;height:35px}.mz-input::placeholder{font-style:italic;text-transform:capitalize;font-size:.8rem}.VueTables__table td,.VueTables__table th,.VueTables__table tr{border:1px solid rgba(128,128,120,.6)!important}.vue-table-cards .buttons-row .number-of-records{position:absolute;left:0;margin-bottom:-53px}.vue-table-cards td,.vue-table-cards th,.vue-table-cards tr{border:1px solid transparent!important}.vue-table-cards .VueTables__table.mz-table>tbody>tr.VueTables__row td{padding:0!important;background:0 0!important;border:none!important}.VueTables__table.mz-table>tbody>tr.VueTables__row>td{background:#f5f6f8!important;border-top:none!important}.VueTables__table.mz-table>tbody>tr.VueTables__child-row td{background:#ecedf1!important;border-top:none!important}.VueTables__child-row .VueTables__filters-row,.hide-table-filters .VueTables__filters-row{display:none!important}.VueTables__table.mz-table>tbody td,.VueTables__table.mz-table>tbody tr.VueTables__child-row.is_open>td{border-bottom:3px solid #fff!important}.VueTables__table.mz-table>tbody tr.VueTables__child-row td,.VueTables__table.mz-table>tbody tr.VueTables__row.is_open td{border-bottom:none!important}.VueTables__table.mz-table>tbody tr.VueTables__child-row.is_open>td,.VueTables__table.mz-table>tbody tr.VueTables__row.is_open td:first-child{border-left:3px solid #787878!important}.VueTables__table.mz-table .mz-input{box-shadow:none!important;border:none!important;height:22px!important;padding-left:0!important;padding-right:0!important;padding-top:6px!important;background:0 0!important}.VuePagination nav p{position:absolute;left:0;max-width:250px}.VueTables--server .VuePagination nav p{display:none}.VuePagination nav p,.VuePagination nav ul{margin-bottom:0;display:flex;align-items:center}.vue-table-wrapper{position:relative}.per-page-wrapper{display:flex;align-items:center;position:absolute;z-index:2;width:270px;margin-left:auto;right:0;bottom:0;justify-content:center}.per-page-wrapper .table-select{margin:0 10px}@media screen and (max-width:1480px){.VuePagination{left:0;height:auto;margin-bottom:25px}.VuePagination nav p{position:absolute;top:10px}.VuePagination nav p,.VuePagination__pagination,.per-page-wrapper{display:block}.VuePagination nav p{position:relative!important;margin:auto}.per-page-wrapper{position:relative;margin-right:auto;margin-left:auto;display:flex;align-items:center}.per-page-select{width:auto;max-width:80px}}@media screen and (max-width:1160px){.per-page-wrapper{position:relative!important;margin:auto;top:-10px}}.table-select{width:100px;display:inline}.vue-table-cards tbody{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));grid-gap:1rem;grid-auto-flow:dense}.vue-table-row-template tbody{display:flex;flex-wrap:wrap;padding-bottom:10px}.vue-table-cards tr{background:rgba(236,236,236,.5);display:inline-block;cursor:pointer;padding:10px;position:relative}.vue-table-row-template tr{background:0 0;padding:0}.vue-table-cards td{display:block;border:none;padding:0;outline:0;white-space:normal}.vue-table-cards thead,.vue-table-cards thead tr{background:0 0;display:flex;justify-content:flex-end;flex-wrap:wrap;padding:0}.vue-table-cards thead{margin-bottom:15px}.vue-table-cards thead tr:first-of-type{margin-top:0}.vue-table-cards th{display:none;align-items:center;padding-left:8px;padding-right:8px}.vue-table-cards .VueTables__filters-row th{display:flex;background:0 0;padding:0!important;border:none!important}.vue-table-cards .VueTables__filters-row input{margin-right:4px;margin-top:-2px;width:auto!important;overflow:auto;height:36px!important;padding-bottom:0}.vue-table-cards .mz-table .VueTables__filters-row{margin-left:6px}.vue-table-cards .mz-table .VueTables__no-results td{border:none!important}.vue-table-cards .mz-table .VueTables__sortable{padding-top:0;padding-bottom:0!important}.vue-table-cards .mz-table .VueTables__sortable:hover{background-color:var(--primary-hover);color:var(--fullwhite)}.vue-table-cards .VueTables__sortable{display:flex;user-select:none;border-radius:.25rem;background-color:transparent;border:1px solid var(--primary)!important;color:var(--primary);font-weight:500;margin-right:4px;outline:0;transition:all .4s ease;height:35px}.clear-filter{margin-top:2px}.clear-filter .fa-filter{font-size:.6rem}.clear-filter .fa-filter::after{content:\"\";display:block;width:14px;height:3px;border-bottom:1px solid #000;transform:rotate(45deg) translate(-6px,-6px);background:#fff}.nested-rows tbody tr,.nested_rows tbody tr td{background:red!important}.dropdown-check-input .custom-checkbox .custom-control-label::after{left:-24px!important}.mz-table .is-numerical-column,.mz-table .is-numerical-column .VueTables__heading{text-align:right}.mz-table .is-numerical-column input{margin-right:-10px;padding-right:0!important}.mz-table .shrink-size input{display:none!important}.examples-tooltip{display:block}.bootstrap-datetimepicker-widget{min-width:261px}.bootstrap-datetimepicker-widget td,.bootstrap-datetimepicker-widget th,.bootstrap-datetimepicker-widget tr{border:none!important}.file-button-container .mz-icon-btn{width:30.24px;height:28.8px}.file-button-container .btn-sm{border-radius:0}.table-details{margin-top:-42px}.table-details .columns-dropdown{margin-right:100px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: "VtPerPage",
  props: ['props'],
  methods: {
    setPerPageValue(value) {
      this.$root.$emit('perPageSet', value);
    },

    getPerPageText() {
      return this.props.opts.texts.showPerPageText.split('|');
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vt-per-page-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.getPerPageText()[0]))]), _vm._v(" "), _c('MzSelect', {
    attrs: {
      "value": _vm.props.limit,
      "options": _vm.props.perPageValues
    },
    on: {
      "update:value": _vm.setPerPageValue
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getPerPageText()[1]))])], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-2f7cc829_0", {
    source: ".vt-per-page-wrapper{display:flex;flex-direction:row;align-items:center}.vt-per-page-wrapper .mz-select-wrapper{min-width:90px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: "VtPagination",
  props: ['props']
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.props.totalPages > 1 ? _c('MzPagination', {
    attrs: {
      "active-page": _vm.props.page,
      "pages": _vm.props.totalPages,
      "firstNumber": true,
      "lastNumber": true,
      "align": "center"
    },
    on: {
      "update:activePage": [function ($event) {
        return _vm.$set(_vm.props, "page", $event);
      }, function (page) {
        return _vm.props.setPage(page);
      }],
      "update:active-page": function ($event) {
        return _vm.$set(_vm.props, "page", $event);
      }
    }
  }) : _vm._e();
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$3 = {
  name: "TableCell",
  props: ['props'],
  computed: {
    className() {
      const callback = this.props.opts.cellClassesCallbacks[this.props.column];

      if (callback) {
        return callback(this.props.row, this.props.column) || '';
      }

      return '';
    }

  },
  components: {
    vnodes: {
      functional: true,
      render: (h, ctx) => typeof ctx.props.vnodes === 'object' ? ctx.props.vnodes : [ctx.props.vnodes]
    }
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('td', {
    class: _vm.props.classes + ' ' + _vm.className,
    attrs: {
      "tabindex": _vm.props.tabIndex || -1
    }
  }, [_c('vnodes', {
    attrs: {
      "vnodes": _vm.props.content
    }
  })], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TableComponent: __vue_component__,
  VtPerPage: __vue_component__$1,
  VtPagination: __vue_component__$2,
  TableCell: __vue_component__$3
});

const stylingCallback = tableClassess => {
  return {
    framework: 'bootstrap4',
    table: `table ${tableClassess ? tableClassess : 'table-hover table-bordered table-sm table-nowrap'}`,
    row: 'row',
    column: 'col-md-12',
    label: '',
    input: `form-control ${tableClassess ? 'mz-input' : ''}`,
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'float-right',
    left: 'float-left',
    center: 'text-center',
    contentCenter: 'justify-content-center',
    nomargin: 'm-0',
    groupTr: 'table-info',
    small: '',
    button: 'btn btn-secondary',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: 'dropdown-item',
      caret: 'caret'
    },
    pagination: {
      nav: '',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled'
    }
  };
};
const hidesDefaultPerPageWhenCustomIsLoaded = (params, component) => {
  if (component.name === "table-component" && params.overrideComponents) {
    component.props.defaultPerPageSelector = {
      default: !params.overrideComponents.perPageSelector,
      type: Boolean
    };
  }
};

// Import vue components

const install = async function installMzRd(Vue, parameters = {}) {
  const isMzTable = parameters.tableClassess && parameters.tableClassess.includes('mz-table');

  if (isMzTable) {
    const defaultMzComponents = {
      perPageSelector: __vue_component__$1,
      pagination: __vue_component__$2
    };

    if (parameters.overrideComponents) {
      parameters.overrideComponents = { ...defaultMzComponents,
        ...parameters.overrideComponents
      };
    } else {
      parameters = { ...parameters,
        overrideComponents: defaultMzComponents
      };
    }
  }

  const tableOptions = parameters.tableOptions || {};
  const tableTexts = { ...(tableOptions.texts || {})
  };
  tableOptions.texts = tableTexts;
  Vue.use(VueTables.ServerTable, { ...tableOptions
  }, false, () => stylingCallback(parameters.tableClassess), {
    tableCell: __vue_component__$3,
    ...parameters.overrideComponents
  });
  Vue.use(VueTables.ClientTable, { ...tableOptions
  }, false, () => stylingCallback(parameters.tableClassess), {
    tableCell: __vue_component__$3,
    ...parameters.overrideComponents
  });
  Vue.use(VueTables.Event);
  Vue.component('v-style', {
    render: function (createElement) {
      return createElement('style', this.$slots.default);
    }
  });
  const apiUrl = parameters.apiUrl || '/';
  const language = parameters.language || 'en';
  const showFilterHelp = parameters.showFilterHelp !== false ? true : parameters.showFilterHelp;

  const onDownloadCallback = parameters.onDownloadCallback || function () {};

  const sendAnalyticsAction = parameters.sendAnalyticsAction || function () {};

  if (parameters.tooltipDirective) Vue.directive('tooltip', parameters.tooltipDirective);
  Object.entries(components).forEach(([componentName, component]) => {
    component.props.apiUrl = {
      default: apiUrl,
      type: String
    };
    component.props.language = {
      default: language,
      type: String
    };
    component.props.showFilterHelp = {
      default: showFilterHelp,
      type: Boolean
    };
    component.props.tableClassess = {
      default: parameters.tableClassess,
      type: String
    };
    component.props.onDownloadCallback = {
      default: onDownloadCallback,
      type: Function
    };
    component.props.sendAnalyticsAction = {
      default: sendAnalyticsAction,
      type: Function
    };
    component.props.tableTexts = {
      default: () => tableTexts,
      type: Object
    };
    hidesDefaultPerPageWhenCustomIsLoaded(parameters, component);

    if (componentName === "TableComponent") {
      if (parameters.tokenBearer) component.props.tokenBearer.default = parameters.tokenBearer;
      if (parameters.handleRequestError) component.props.handleRequestError.default = parameters.handleRequestError;
    }

    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export default install;
export { __vue_component__$3 as TableCell, __vue_component__ as TableComponent, __vue_component__$2 as VtPagination, __vue_component__$1 as VtPerPage };
